export const PAST_PERIOD_COLOR = "#35B266";
export const CURRENT_PERIOD_COLOR = "#4D3899";

export const getPeriodColor = (days, currentPeriodStartDate, index) => {
  const isCurrentPeriodDay =
    Boolean(currentPeriodStartDate) && days[index] >= currentPeriodStartDate;

  return isCurrentPeriodDay ? CURRENT_PERIOD_COLOR : PAST_PERIOD_COLOR;
};
